import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d9e2ea3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-font-size mb--20" }, "Техническая поддержка пользователей", -1))
const _hoisted_2 = { class: "center mt--20" }

import { Ref, ref } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { ErrorsType } from '@/types';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';

export type FormDataType = {
  title: string | undefined;
  comment: string | undefined;
  files: (FileList | null)[];
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserSupport',
  setup(__props) {

const formData: Ref<FormDataType> = ref({
  title: '',
  comment: '',
  files: [],
});

const formKey: Ref<number> = ref(0);
const clearFormData = () => {
  formKey.value++;
  v$.value.$reset();
  formData.value.title = '';
  formData.value.comment = '';
  formData.value.files = [];
};
const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  title: { required },
  comment: { required },
  files: {},
};

const v$ = useVuelidate<FormDataType>(rules, formData);
const errors: Ref<ErrorsType> = ref({});
const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const isLoading = ref(false);

const prepareDataForSend = (): FormData => {
  let sendData = new FormData();

  sendData.append(`parameters[title]`, String(formData.value.title));
  sendData.append(`parameters[comment]`, String(formData.value.comment));
  if (formData.value.files) {
    Object.values(formData.value.files).forEach(val => {
      if (val !== null) {
        sendData.append('parameters[files][]', val);
      }
    });
  }

  return sendData;
};
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value?.$touch();
    validationErrorsHandler();

    return;
  }

  isLoading.value = true;
  try {
    const res = await useUserStore().sendSupport(prepareDataForSend());

    if (res) {
      useUserStore().addItemToSupportList({
        title: formData.value.title || '',
        comment: formData.value.comment || '',
      });
      useAppStore().openAlert('', 'Сообщение отправлено', 'success');
      clearFormData();
    }
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    isLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_textarea = _resolveComponent("base-textarea")!
  const _component_base_file_input = _resolveComponent("base-file-input")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_card = _resolveComponent("base-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_card, {
      class: "user-support",
      "full-width-mobile": ""
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        (_openBlock(), _createBlock(_component_base_form, { key: formKey.value }, {
          default: _withCtx(() => [
            _createVNode(_component_base_input, {
              modelValue: formData.value.title,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.title) = $event)),
              error: errors.value.title,
              invalid: !!errors.value.title,
              height: "36",
              label: "Тема",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('title'))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.title)),
              onInput: _unref(v$).title?.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
            _createVNode(_component_base_textarea, {
              modelValue: formData.value.comment,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.comment) = $event)),
              error: errors.value.comment,
              invalid: !!errors.value.comment,
              class: "mt--20",
              height: "81",
              label: "Сообщение",
              textarea: "",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('comment'))),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.comment)),
              onInput: _unref(v$).comment?.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
            _createVNode(_component_base_file_input, {
              modelValue: formData.value.files,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.files) = $event)),
              error: errors.value.files,
              invalid: !!errors.value.files,
              class: "mt--20",
              height: "36",
              label: "Прикрепить файлы",
              multiple: "",
              withIcon: "",
              onBlur: _cache[7] || (_cache[7] = ($event: any) => (validationErrorsHandlerByKey('files'))),
              onFocus: _cache[8] || (_cache[8] = ($event: any) => (delete errors.value.files)),
              onInput: _unref(v$).files.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"])
          ]),
          _: 1
        })),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_base_button, {
            loading: isLoading.value,
            height: "36",
            text: "Отправить",
            type: "submit",
            width: "165",
            onClick: formSubmit
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})